import styled from 'styled-components';
import { BaseDropMenu, GetColor, Icon, ZIndex } from 'venn-ui-kit';

export const separatorClassName = 'menuOption-separator';

export const ActionsButton = styled.button`
  width: 100%;
  cursor: pointer;
  i {
    line-height: 30px;
  }
`;

export const GreyIcon = styled(Icon)`
  color: ${GetColor.GreyScale.Grey80};
  &:hover {
    color: ${GetColor.Primary.Main};
  }
`;

export const AllocatorPanelRowActionsDropMenu = styled(BaseDropMenu)`
  position: absolute;

  &.drop-menu {
    width: 232px;
    > div {
      max-height: 322px;
    }
    > div > div {
      min-width: 210px;
      > div {
        padding-top: 0px;
        padding-bottom: 0px;
      }
    }
    z-index: ${ZIndex.StickyCover};
    position: relative;
  }
  .${separatorClassName}:not(:last-child) {
    border-bottom: 1px solid ${GetColor.GreyScale.Grey40};
  }
`;
